import React from 'react';
import {Container, Overlay, Title, TitleContainer, Content} from "./right-menu.styles";

const RightMenu = ({title, active, onCloseMenu, children}) => {
    return (
        <>
            <Overlay onClick={onCloseMenu} active={active}/>
            <Container className={active ? 'active' : ''}>
                <Content className={active ? 'active' : ''}>
                    <TitleContainer className='d-flex align-items-center justify-content-between lng-dir'>
                        <Title className='mb-0'>{title}</Title>
                        <button className='simple-btn' onClick={onCloseMenu}>
                            <i className="fas fa-times fa-mdb main-text-color"/>
                        </button>
                    </TitleContainer>
                    <div className='p-3'>
                        {children}
                    </div>
                </Content>
            </Container>
        </>
    );
};

export default RightMenu;
